<template>
    <div>
        <h1 class="service-title title is-1">Right-of-way Maintenance</h1>
        <div class="service-content no-nav">
            <div class="columns">
                <div class="column is-8">
                    <p>
                        Gulf Coast Contractors has been providing vegetation maintenance services to TxDot,
                        Cities and Counties for over 20 years. Our expert staff is committed to provide high quality
                        service to our customers while operating in a safe manner among the traveling public.
                        As with all the services we provide, the Gulf Coast team will always provide a level of
                        quality and accountability that is second to none.
                    </p>
                    <hr/>
                    <div class="page-section content">
                        <dl>
                            <dt>Litter Removal</dt>
                            <dd>
                                Complete litter removal services within the roadway limits are provided on a routine basis, both before a cycle of mowing and on an interim basis.  All litter is bagged and removed from the roadway on the same day with disposal receipts provided upon request.
                            </dd>

                            <dt>Roadside Mowing</dt>
                            <dd>
                                We maintain a  fleet of John Deere tractors with 15’  mowing decks for large machine mowing services.  We also operate several zero turn mowing crews for mowing of smaller, curbed or limited access areas.
                            </dd>

                            <dt>Roadside Edging & Sweeping</dt>
                            <dd>
                                We have performed over 5000 miles of roadway edging services annually statewide.  Through both mechanical and manual means our staff will provide your roadways with the finished, manicured look only proper edging of grass can provide.  Our unique ability to provide a street sweeper along with the operation leaves the entire site looking clean and complete each day.
                            </dd>

                            <dt>Herbicide Application</dt>
                            <dd>
                                Our fully licensed herbicide team will provide the proper equipment and materials to apply herbicide to any areas our customer needs.  Our application vehicles are able to reach any area service is needed – on road or off. Typical areas we provide service are sidewalk and curbing crack weeds, on bridge and barrier walls, along fence lines and behind guardrail.  Full documentation is provide each day including amount of herbicide applied, locations applied and wind speed.
                            </dd>
                        </dl>
                    </div>
                </div>
                <div class="column is-4">
                    <img src="../../assets/content/highwaymow.jpg">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'rows',
        data () {
            return {}
        }
    }
</script>



// WEBPACK FOOTER //
// Rows.vue?238015bb